import PhaseDTO from "./PhaseDTO.js"
import PlayerDTO from "./PlayerDTO.js"
import StadiumDTO from "./StadiumDTO.js"
import TeamDTO from "./TeamDTO.js"

class SportEventDTO {

    constructor(sportEventData){
        if(!sportEventData || Object.keys(sportEventData).length === 0)
            return

        const {_id, provider, type = 'team', name, date, phase, stadium, players = [], teams = [], mainSport, competitionIdName, competition, photoName, photoUrl} = sportEventData

        this._id = _id
        this.provider = provider

        this.type = type

        this.name = name
        this.date = date

        //this.stadium = new StadiumDTO(stadium)

        this.phase = new PhaseDTO(phase)

        this.teams = teams?.map(team => new TeamDTO(team))
        this.players = players?.map(player => new PlayerDTO(player))

        //References usefull for webhook & data manipulation on server side
        this.mainSport = mainSport
        this.competitionIdName = competitionIdName
        this.competition = competition
        
        this.photoName = photoName
        this.photoUrl = photoUrl
    }

}

export default SportEventDTO